import { render } from "./pending-items-modal.vue?vue&type=template&id=1476258f"
import script from "./pending-items-modal.vue?vue&type=script&lang=js"
export * from "./pending-items-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__